import React from "react";
import { Linking, View, ScrollView, StyleSheet } from "react-native";
import { CalendarBlank, CaretRight, Warning } from "@phosphor-icons/react";
import CustomText from "../../common/general/CustomText/CustomText";
import CustomButton from "../../common/general/CustomButton/CustomButton";

const SupportTab = ({ supportData }) => (
  <ScrollView style={{ flex: 1 }} tabIndex={0}>
    {/* <View style={styles.section}>
      <DeviceMobileCamera size={20} color="#0084FF" />
      <View style={styles.content}>
        <CustomText size="m" text="Phone Support" style={styles.title} />
        <CustomText
          size="s"
          text="call_us_at"
          interpolation={{ phoneNumber: "(555) 123-4567" }}
          style={styles.subtitle}
        />
      </View>
      <CaretRight size={16} color="#667085" />
    </View> */}

    {supportData.reportProblemUrl && (
      <View style={styles.section}>
        <Warning size={20} color="#E31B53" />
        <View style={styles.content}>
          <CustomText size="m" text="Report a Problem" style={styles.title} />
          <CustomText size="s" text="Technical Issues or Concerns" style={styles.subtitle} />
        </View>
        <CustomButton
          onPress={() => Linking.openURL(supportData.reportProblemUrl)}
          text={null}
          leftIcon={<CaretRight size={16} color="#667085" />}
          size="s"
          styleType="transparent"
          style={{ marginLeft: 4, padding: 0 }}
          aria-label="Report a Problem"
          accessibilityHint="Report a Problem"
        />
      </View>
    )}

    {supportData.scheduleAdvisorCallUrl && (
      <View style={styles.section}>
        <CalendarBlank size={20} color="#007CC1" />
        <View style={styles.content}>
          <CustomText size="m" text="Schedule Advisor Call" style={styles.title} />
          <CustomText size="s" text="Book a 1:1 session" style={styles.subtitle} />
        </View>
        <CustomButton
          onPress={() => Linking.openURL(supportData.scheduleAdvisorCallUrl)}
          text={null}
          leftIcon={<CaretRight size={16} color="#667085" />}
          size="s"
          styleType="transparent"
          style={{ marginLeft: 4, padding: 0 }}
          aria-label="Schedule Advisor Call"
          accessibilityHint="Schedule Advisor Call"
        />
      </View>
    )}
  </ScrollView>
);

const styles = StyleSheet.create({
  section: {
    marginBottom: 12,
    paddingVertical: 12,
    paddingHorizontal: 16,
    flexDirection: "row",
    alignItems: "center",
    backgroundColor: "#F9FAFB",
    borderRadius: 10,
  },
  content: {
    marginHorizontal: 8,
    flex: 1,
  },
  title: {
    fontWeight: "bold",
    color: "#101828",
  },
  subtitle: {
    fontWeight: "normal",
    color: "#475467",
  },
});

export default SupportTab;
